interface SubdomainResult {
  domain: string;
  subdomain: string;
}

export function getSubdomainHelper(url: string | null | undefined): SubdomainResult {
  if (!url) return { domain: '', subdomain: '' };

  let hostname;

  try {
    hostname = new URL(url).hostname;
  } catch {
    hostname = url
      .replace(/^[a-zA-Z]+:\/\//, '')
      .split('/')[0]
      .split('?')[0]
      .split('#')[0];
  }

  const parts = hostname.split('.').filter(Boolean);

  if (parts.length <= 2) {
    return {
      domain: hostname,
      subdomain: '',
    };
  }

  const tlds = ['co.uk', 'com.ua', 'co.jp', 'com.au'];
  const lastTwo = parts.slice(-2).join('.');
  const lastThree = parts.slice(-3).join('.');

  let domain, subdomain;

  if (tlds.includes(lastTwo)) {
    domain = parts.slice(-3).join('.');
    subdomain = parts.slice(0, -3).join('.');
  } else if (tlds.includes(lastThree)) {
    domain = parts.slice(-4).join('.');
    subdomain = parts.slice(0, -4).join('.');
  } else {
    domain = parts.slice(-2).join('.');
    subdomain = parts.slice(0, -2).join('.');
  }

  return {
    domain,
    subdomain,
  };
}
